module.exports = function(selector) {
    return window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content');
};
